<div class="mobile-menu-slider">
  <!-- Main menu -->
  @if (!selectedMain()) {
  <div class="mobile-menu">
    <div class="mobile-header">
      <button class="arrow-btn" (click)="closeModal()">
        <img loading="lazy" src="assets/images/close.svg" alt="" />
      </button>
    </div>
    <div class="mobile-menu-body">
      @if (workcoverLoggedUser()?.email) {
      <ul class="profile">
        <li
          #profileMenuItem
          [routerLink]="['/profile']"
          (click)="closeModal()"
          tabindex="0"
          role="link"
          (keydown.enter)="profileMenuItem.click()"
          (keydown.space)="profileMenuItem.click(); $event.preventDefault()"
        >
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/person-outline.svg" alt="" /></button>
            <p class="name">My Profile</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        <!-- <li [routerLink]="fetchBusinessRouting()" (click)="closeModal();" *ngIf="hasBusiness">
            <div class="menu">
              <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/dashboard.svg" alt=""></button>
              <p class="name">Business Dashboard</p>
            </div>
            <button class="arrow-btn no-bg"><img src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
          </li> -->
        <!-- <li [routerLink]="['wellbeing']" (click)="closeModal();" *ngIf="isWellbeingOwner">
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/dashboard.svg" alt=""></button>
            <p class="name">Wellbeing Dashboard</p>
          </div>
          <button class="arrow-btn no-bg"><img src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
        </li> -->
      </ul>
      } @if (workcoverLoggedUser()?.email) {
      <ul class="logout-holder">
        <li>
          <a
            tabindex="0"
            role="button"
            (click)="signOut()"
            (keydown.enter)="signOut()"
            (keydown.space)="signOut(); $event.preventDefault()"
            >Logout <i class="fa fa-arrow-right-from-bracket"></i
          ></a>
        </li>
      </ul>
      }
      <!-- <ul class="on-mobile">
    <li (click)="selectedMain.set('wellbeing')">
      <div class="menu">
        <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/fitness.svg" alt=""></button>
        <p class="name">Wellbeing Services</p>
      </div>
      <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
    </li>
    <li (click)="selectedMain.set('others'); selectedGroup.set('Online Services')">
      <div class="menu">
        <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/video.svg" alt=""></button>
        <p class="name">Online Services</p>
      </div>
      <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
    </li>
    <li (click)="selectedMain.set('others'); selectedGroup.set('Health Conditions')">
      <div class="menu">
        <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/heart.svg" alt=""></button>
        <p class="name">Health Conditions</p>
      </div>
      <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
    </li>
    <li [routerLink]="['/blog']" (click)="closeModal()">
      <div class="menu">
        <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/notification.svg" alt=""></button>
        <p class="name">Health Hub</p>
      </div>
      <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
    </li>
  </ul> -->
      @if (!workcoverLoggedUser()?.email) {
      <div class="login-buttons">
        <button class="secondary" (click)="closeModal()" [routerLink]="['/login']">Login</button>
        <!-- <button class="primary" (click)="closeModal()" [routerLink]="['/sign-up']">Register</button> -->
      </div>
      }
      <!-- <div class="or-divider">
  <div class="or-border"></div>
  <p class="or-txt sml-txt">OR</p>
  <div class="or-border"></div>
</div> -->
      <!-- <ul>
<li>
  <a href="https://listyourbusiness.avaana.com.au" target="_blank" (click)="closeModal();">
    <div class="menu">
      <p class="name">List your business for free</p>
    </div>
    <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
  </a>
</li>
<li>
  <a href="https://ndis.avaana.com.au/" target="_blank" (click)="closeModal();">
    <div class="menu">
      <p class="name">Get NDIS registered</p>
    </div>
    <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
  </a>
</li>
<li [routerLink]="['/workplacewellbeing']" (click)="closeModal();">
  <div class="menu">
    <p class="name">Corporate wellbeing</p>
  </div>
  <button class="arrow-btn no-bg"><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
</li>
<li [routerLink]="['/workcoverbusiness']" (click)="closeModal();">
  <div class="menu">
    <p class="name">Workcover business</p>
  </div>
  <button class="arrow-btn no-bg"><img src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
</li>
</ul> -->
    </div>
  </div>
  }

  <!-- Wellbeing Services -->
  @if (selectedMain() === 'wellbeing' && !selectedGroup()) {
  <div class="mobile-menu others">
    <div class="mobile-header">
      <button class="arrow-btn" (click)="selectedMain.set(''); selectedGroup.set(''); selectedService.set(undefined)">
        <img loading="lazy" src="assets/images/booking/left-arrow.svg" alt="left arrow" />
      </button>
      <h2>Wellbeing Services</h2>
    </div>
    <div class="mobile-menu-body">
      <ul>
        <li
          tabindex="0"
          role="button"
          (click)="selectedGroup.set('Physical')"
          (keydown.enter)="selectedGroup.set('Physical')"
          (keydown.space)="selectedGroup.set('Physical'); $event.preventDefault()"
        >
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/fitness.svg" alt="" /></button>
            <p class="name">Physical</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        <li
          tabindex="0"
          role="button"
          (click)="selectedGroup.set('Mental')"
          (keydown.enter)="selectedGroup.set('Mental')"
          (keydown.space)="selectedGroup.set('Mental'); $event.preventDefault()"
        >
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/video.svg" alt="" /></button>
            <p class="name">Mental</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        <li
          tabindex="0"
          role="button"
          (click)="selectedGroup.set('Natural')"
          (keydown.enter)="selectedGroup.set('Natural')"
          (keydown.space)="selectedGroup.set('Natural'); $event.preventDefault()"
        >
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/heart.svg" alt="" /></button>
            <p class="name">Natural</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        <li
          tabindex="0"
          role="button"
          (click)="selectedGroup.set('Fitness')"
          (keydown.enter)="selectedGroup.set('Fitness')"
          (keydown.space)="selectedGroup.set('Fitness'); $event.preventDefault()"
        >
          <div class="menu">
            <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/notification.svg" alt="" /></button>
            <p class="name">Fitness</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
      </ul>
    </div>
  </div>
  }

  <!-- Physical | Mental | Natural | Fitness | Online | Health Conditions -->
  @if (selectedGroup() && !(selectedService())) {
  <div class="mobile-menu others">
    <div class="mobile-header">
      <button class="arrow-btn" (click)="goBackFromGroups()">
        <img loading="lazy" src="assets/images/booking/left-arrow.svg" alt="left arrow" />
      </button>
      <h2>{{ selectedGroup() }}</h2>
    </div>
    <div class="mobile-menu-body">
      <ul>
        @if (selectedGroup() !== 'Health Conditions') { @for (item of headerCategories[selectedGroup()]; track item) {
        <li>
          <div class="menu">
            <p
              class="name"
              tabindex="0"
              role="button"
              (click)="goToCategoryPage(item)"
              (keydown.enter)="goToCategoryPage(item)"
              (keydown.space)="goToCategoryPage(item); $event.preventDefault()"
            >
              {{ item.name }}
            </p>
          </div>
          <button class="arrow-btn no-bg" (click)="selectService(item)">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        } } @else { @for (item of healthConditionList; track item) {
        <li
          tabindex="0"
          role="button"
          (click)="selectService(item)"
          (keydown.enter)="selectService(item)"
          (keydown.space)="selectService(item); $event.preventDefault()"
        >
          <div class="menu">
            <!-- <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/fitness.svg" alt=""></button> -->
            <p class="name">{{ item.name }}</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        } }
      </ul>
    </div>
  </div>
  }

  <!-- Suburbs -->
  @if (selectedGroup() && selectedService()) {
  <div class="mobile-menu others">
    <div class="mobile-header">
      <button class="arrow-btn" (click)="selectedService.set(undefined)">
        <img loading="lazy" src="assets/images/booking/left-arrow.svg" alt="left arrow" />
      </button>
      <h2>{{ selectedService().name }}</h2>
    </div>
    <div class="mobile-menu-body">
      <ul>
        @if (selectedGroup() !== 'Health Conditions') { @for (city of selectedService().cities; track city) { @for (suburb
        of city.suburbs; track suburb) {
        <li
          tabindex="0"
          role="button"
          (click)="goToServicePage(selectedService(), suburb)"
          (keydown.enter)="goToServicePage(selectedService(), suburb)"
          (keydown.space)="goToServicePage(selectedService(), suburb); $event.preventDefault()"
        >
          <div class="menu">
            <!-- <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/fitness.svg" alt=""></button> -->
            <p
              class="name"
              tabindex="0"
              role="button"
              (click)="goToCategoryPage(selectedService(), suburb)"
              (keydown.enter)="goToCategoryPage(selectedService(), suburb)"
              (keydown.space)="goToCategoryPage(selectedService(), suburb); $event.preventDefault()"
            >
              {{ suburb.name }}
            </p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        } } } @else { @for (suburb of selectedService().suburb; track suburb) {
        <li
          tabindex="0"
          role="button"
          (click)="goToHealthConditionPage(selectedService(), suburb)"
          (keydown.enter)="goToHealthConditionPage(selectedService(), suburb)"
          (keydown.space)="goToHealthConditionPage(selectedService(), suburb); $event.preventDefault()"
        >
          <div class="menu">
            <!-- <button class="arrow-btn"><img loading="lazy" src="assets/images/menu/fitness.svg" alt=""></button> -->
            <p class="name">{{ suburb.city }}</p>
          </div>
          <button class="arrow-btn no-bg">
            <img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow" />
          </button>
        </li>
        } }
      </ul>
    </div>
  </div>
  }
</div>
